import React, { useEffect, useMemo, useState } from "react";
import { FaEye, FaPen, FaUserCog } from "react-icons/fa";
import styles from "./syllabus.module.css";
import AxiosInstance, { TokenService } from "../../../../services/Api";
import { CustomButton, CustomDropdown } from "../../../../components";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchStaffClassAndSubjects } from "../../../../redux/Masterdata";
import PopupModal from "../../../../components/PopupModal/PopupModal";

const Syllabus = () => {
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || {};
  const school_id = clientData?.school_id || "";
  const master_id = clientData?.master_id || "";
  const { translations } = useSelector((state) => state.language);
  const navigate = useNavigate(); // ✅ hook at top level
  const dispatch = useDispatch();
  const [classValue, setClassValue] = useState(null);
  const [sectionValue, setSectionValue] = useState(null);
  const [subjectValue, setSubjectValue] = useState(null);
  const [apiSearch, setApiSearch] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50, // timetable usually needs bigger page size
  });
  const [errors, setErrors] = useState({});
  const [modalState, setModalState] = useState({
    open: false,
    type: "success",   // "success" | "error"
    message: "",
    redirectPath: "",
  });
  // Get master data from Redux store
  const {
    staffClassAndSubjectOptions: reduxClassOptions,
    sectionOptions: reduxSectionOptions,
  } = useSelector((state) => state.masterData);
  useEffect(() => {
    if (classValue && sectionValue) {
      fetchDaySchedule();
    }
  }, [classValue, sectionValue]);
  const fetchDaySchedule = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post("/timeTable/scheduleList", {
        school_id: school_id,
        class_id: classValue?.value,
        section: sectionValue?.value,
        shift_id: "",
      });

      if (response?.data) {
        setTableData(response.data.data || []);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching day schedule", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!classValue) newErrors.classValue = translations.errors.classRequired;
    if (!sectionValue)
      newErrors.sectionValue = translations.errors.sectionRequired;
    return newErrors;
  };

  const handleView = (rowData) => {
    
    navigate("/user/viewSyllabus",{
      state:{
        SYLLABUSID:rowData.syllabus_id,
        SECTION:rowData.section_id,
      }
    })
  };

  const handleDropdownChange = (field, value, setter) => {
    setter(value); // value MUST be full object

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));

    if (field === "classValue") {
      setSectionValue("");
      setSubjectValue("");
    }

    if (field === "sectionValue") {
      setSubjectValue("");
    }
  };
  const classOptions = useMemo(() => {
    const seen = new Set();
    return (reduxClassOptions || [])
      .filter((item) => {
        if (seen.has(item.class_id)) return false;
        seen.add(item.class_id);
        return true;
      })
      .map((item) => ({
        value: item.class_id,
        label: item.class_name,
      }));
  }, [reduxClassOptions]);

  const sectionOptions = useMemo(() => {
    if (!classValue) return [];

    const seen = new Set();

    return reduxClassOptions
      .filter((item) => item.class_id === classValue?.value)
      .filter((item) => {
        if (seen.has(item.section_id)) return false;
        seen.add(item.section_id);
        return true;
      })
      .map((item) => ({
        value: item.section_id,
        label: item.section_id,
      }));
  }, [reduxClassOptions, classValue]);


  const subjectOptions = useMemo(() => {
    const seen = new Set();
    return (reduxClassOptions || [])
      .filter((item) => {
        if (seen.has(item.subject_id)) return false;
        seen.add(item.subject_id);
        return true;
      })
      .map((item) => ({
        value: item.subject_id,
        label: item.subject_name,
      }));
  }, [reduxClassOptions]);

  useEffect(() => {
    dispatch(
      fetchStaffClassAndSubjects({
        //    staff_id: parseInt(staff_id),
        staff_id: master_id,
        class_id: classValue?.value || "",
        section_id: sectionValue?.value || "",
        subject_id: subjectValue?.value || "",
      }),
    );
  }, [dispatch, school_id, classValue, sectionValue, subjectValue]);
  const handleCancel = () => {
    setClassValue(null);
    setSectionValue(null);
    setSubjectValue(null);

  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        staff_id: master_id,
        class_id: classValue?.value || "",
        section_id: sectionValue?.value,
        subject_id: subjectValue?.value,
        page: 1,
        limit: 10,
      };
      const response = await AxiosInstance.post(
        `/school/staff/listSyllabus`,
        payload,
      );
      if (response.data?.status) {
        setTableData(response.data.data);
       


      } else {
        // ✅ graceful handling
        setTableData([]);
        setModalState({
          open: true,
          type: "error",
          message: response.data?.message,
          redirectPath: "",
        });
      }
    }
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "class_name",
        header: translations.labels.class,
        muiFilterTextFieldProps: {
          placeholder: "Filter by Class",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },
      {
        accessorKey: "section_id",
        header: translations.labels.section,
        muiFilterTextFieldProps: {
          placeholder: "Filter by Setion",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },
      {
        accessorKey: "subject_name",
        header: translations.labels.subject,
        muiFilterTextFieldProps: {
          placeholder: "Filter by subject",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },
      {
        accessorKey: "chapter",
        header: translations.labels.chapter,
        muiFilterTextFieldProps: {
          placeholder: "Filter by Chapter",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },
      {
        accessorKey: "units",
        header: translations.labels.unit,
        muiFilterTextFieldProps: {
          placeholder: "Filter by Unit",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },
      {
        accessorKey: "short_description",
        header: translations.labels.shortDescription,
        muiFilterTextFieldProps: {
          placeholder: "Filter by Short Description",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },
      {
        accessorKey: "isActive",
        header: translations.labels.status,
        Cell: ({ cell }) => (
          <span>
            {Number(cell.getValue()) === 1 ? "Active" : "Inactive"}
          </span>
        ),
        muiFilterTextFieldProps: {
          placeholder: "Filter by status",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              setApiSearch(e.target.value);
              setPagination((prev) => ({ ...prev, pageIndex: 0 }));
            }
          },
        },
      },



      {
        id: "actions",
        header: translations.labels?.actions || "Actions",
        enableSorting: false,
        Cell: ({ row }) => (
          <button
            className={styles.viewBtn}
            onClick={() => handleView(row.original)}
            title={translations.labels?.viewStudent || "View Student"}
          >
            <FaEye />
          </button>
        ),
      },

    ],
    [],
  );
  const handleEdit = (data) => {
    navigate("/user/AddHallOfFame", {
      state: {

      },
    });

  };
  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;
    setModalState((prev) => ({
      ...prev,
      open: false,
    }));
    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };
  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>

          <h1 className={styles.headerTitle}>
            {" "}
            {translations?.labels?.syllabusList || "Syllabus List"}
          </h1>
        </div>
        <form onSubmit={handleSubmit} className="row g-3 align-items-center">
          {/* Class */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations?.labels?.classLabel}
              value={classValue}          // must be {label, value}
              options={classOptions}
              onChange={(v) =>
                handleDropdownChange("classValue", v, setClassValue)
              }
              placeholder={translations?.labels?.classPlaceholder}
              required
              error={errors.classValue}
            />

          </div>
          {/* Section */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations?.labels?.sectionLabel}
              value={sectionValue}
              options={sectionOptions}
              onChange={(v) =>
                handleDropdownChange("sectionValue", v, setSectionValue)
              }
              required
            />

          </div>
          {/* Subject */}

          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.subject}
              value={subjectValue}
              options={subjectOptions}
              onChange={(v) =>
                handleDropdownChange("subjectValue", v, setSubjectValue)
              }
              required
            />

          </div>
          <div className="col-md-3 px-2 d-flex align-items-end">
            <div className="d-flex gap-2 w-100">
              <CustomButton
                variant="contained"
                onClick={handleSubmit}
                className={styles.saveButton}
                loading={loading}
              >
                {translations.labels.searchButton}
              </CustomButton>
              <CustomButton
                variant="contained"
                onClick={handleCancel}
                className={styles.cancelButton}
                disabled={loading}            >
                {translations.labels.resetButton}
              </CustomButton>
            </div>
          </div>
        </form>
        {/* ===========================
          TABLE (LOAD AFTER SELECT)
      =========================== */}
        {tableData.length > 0 && (
          <>
            <div className={styles.topBar}>
              <div></div>
              <div className={styles.actions}>
                <button
                  className={styles.iconBtn}
                  onClick={() => handleEdit(tableData)}
                >
                  <FaPen />
                </button>
              </div>
            </div>
            <CustomMRTTable
              columns={columns}
              data={tableData}
              loading={loading}
              pagination={pagination}
              // rowCount={rowCount}
              onPaginationChange={setPagination}
              // searchInput={searchInput}
              // setSearchInput={setSearchInput}
              onSearchEnter={(value) => {
                setApiSearch(value);
                setPagination((prev) => ({ ...prev, pageIndex: 0 }));
              }}

              enableSearch={false}
              enableFiltering={false}
            />
          </>
        )}
      </div>
    </>

  );
};

export default Syllabus;
